import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ModalDismissReasons, NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { isNullOrUndefined } from '@swimlane/ngx-datatable';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppointmentList } from 'projects/Administration/src/app/business-entities/appointmentList-model';
import { AvailableStockBalanceModel,  FilterDataModel, LabourInfoViewModel, PartViewModel, WorkStepDetail, WorkStepResponseModel, WorkViewModel } from 'projects/Administration/src/app/business-entities/tecrmi-model';
import { VehicleListViewModel } from 'projects/Administration/src/app/business-entities/vehicle-list-view-model';
import { EditAppointmentService } from 'projects/Administration/src/app/business-services/edit-appointment.service';
import { TecRMIBusinessService } from 'projects/Administration/src/app/business-services/Tec-RMI.service';
import { VehicleBusinessService } from 'projects/Administration/src/app/business-services/vehicle-service';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { AppointmentWorkOrderComponent } from '../appointment-work-order/appointment-work-order.component';


@Component({
  selector: 'app-tec-rmi-labour-popup',
  templateUrl: './tec-rmi-labour-popup.component.html',
  styleUrls: ['./tec-rmi-labour-popup.component.css']
})
export class TecRmiLabourPopupComponent implements OnInit {

  @ViewChild(AppointmentWorkOrderComponent) child: AppointmentWorkOrderComponent;
  openPanels: Array<string> = ['first-panel', 'second-panel', 'third-panel'];
  labourWorkList: LabourInfoViewModel[];

  // labour
  selectedLabourWorkFromStep1: LabourInfoViewModel[];
  selectedLabourWorkFromStep2: LabourInfoViewModel[];
  isStep1Completed: boolean = false;
  isStep2Completed: boolean = false;
  isStep3Completed: boolean = false;

  // services
  workSteps: WorkStepResponseModel[]
  selectedService: number;
  AddedServicesInCart: WorkStepDetail[] = [];
  selectedServiceName: string;
  selectedServiceId: number;

  appointmentDetails: AppointmentList;
  currentVehicleDetails: VehicleListViewModel;
  tecDocType: any;
  mileage: number;
  regDate: Date;
  cartMainServices: WorkViewModel[];
  cartAdditionalServices: WorkViewModel[];
  cartPartItems: PartViewModel[];
  cartServiceIds: any[];
  clearExtraServies: boolean = false;
  availableStockBalance: AvailableStockBalanceModel[];
  articleStockData: AvailableStockBalanceModel[] = [];
  selectedtab: number = 1
  tabs: any = [
    { id: 1, name: 'lblStep1' },
    { id: 2, name: 'lblStep2' },
    { id: 3, name: 'lblServiceSelection' },
    { id: 4, name: 'lblExclusiveServiceSelection' },
    { id: 5, name: 'lblCheckOut' },
    { id: 6, name: 'lblStockBalance' },
  ]

  @Input() filterModel: FilterDataModel = {
    typeId: null,
    kindOfGearBox: null,
    currentMileage: 0,
    initalRegistrationDate: '',
    cooGroupId: null,
    regDate: ''
  };

  constructor(
    private activeModal: NgbActiveModal,
    private tecRMIService: TecRMIBusinessService,
    private vehicleService: VehicleBusinessService,
    private spinner: NgxSpinnerService,
    public editAppointmentService: EditAppointmentService,
    public translate: TranslateService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.initialize();
  }

  initialize() {
    this.appointmentDetails = this.editAppointmentService.appointmentDetails;
    this.getVehicleDetail();
    this.isStep2Completed = false
    // this.tecDocType = 153759// 60203; //153759; //todo : this should be retrived from vehicle detail
    this.cartPartItems = [];
  }

  getVehicleDetail() {
    this.spinner.show();
    let licensePlate = this.appointmentDetails.licensePlate;
    this.vehicleService.getVehicleByLicencePlateNo(licensePlate).then((result) => {
      if (result) {
        this.currentVehicleDetails = result.responseObject;
        if (this.currentVehicleDetails) {
          this.filterModel.currentMileage = this.currentVehicleDetails.mileage;
          this.filterModel.regDate = this.currentVehicleDetails.registrationDate;
          if (this.currentVehicleDetails.tecDocType != null) {
            this.tecDocType = parseInt(this.currentVehicleDetails.tecDocType)
            this.getLabourWorkList();
          }
          else {
            this.updateTecDocIds();
          }
        }
      }
      this.spinner.hide();
    },
      _error => {
        this.spinner.hide();
      });
  }


  updateTecDocIds() {
    this.spinner.show();
    let licensePlate = this.appointmentDetails.licensePlate;
    this.tecRMIService.updateTecDocIds(licensePlate).then(result => {
      if (result != null) {
        let tecDocType = result
        this.tecDocType = parseInt(tecDocType)
      }
      else {
        this.tecDocType = 153759// 60203; //153759; //todo : this should be retrived from vehicle detail
      }
      this.getLabourWorkList();

      this.spinner.hide();
    },
      _error => {
        this.spinner.hide();
      });
  }

  ManageLabourWorkListInStep1(event, work: LabourInfoViewModel) {
    if (event.target.checked) {
      this.labourWorkList.forEach(x => {
        x.isSelected = false
      });
      work.isSelected = true;
      this.selectedLabourWorkFromStep1 = this.labourWorkList.filter(x => x.isSelected)
      this.isStep2Completed = false;
    }
  }

  ManageLabourWorkListInStep2(event, work: LabourInfoViewModel) {
    if (event.target.checked) {
      this.selectedLabourWorkFromStep1[0].childNodes.forEach(x => {
        x.isSelected = false
      });
      work.isSelected = true;
      this.isStep2Completed = true;
    }
  }

  getSubChildLabourWorkListForStep3() {
    this.selectedLabourWorkFromStep2 = this.selectedLabourWorkFromStep1[0].childNodes?.filter(x => x.isSelected);
  }

  ManageLabourWorkListInStep3(event, work: LabourInfoViewModel) {
    if (event.target.checked) {
      this.selectedLabourWorkFromStep2[0].childNodes.forEach(x => {
        x.isSelected = false
      });
      this.AddedServicesInCart = []
      work.isSelected = true;
      this.isStep3Completed = true;
      this.selectedServiceName = work.nodeName;
      this.selectedServiceId = work.nodeId;
    }
  }

  ServiceSelectionInStep4(event, work: WorkStepDetail) {
    if (event.target.checked) {
      this.AddedServicesInCart.push(work);
      this.selectedService = work.workId;
    }
    else {
      this.AddedServicesInCart = this.AddedServicesInCart.filter(x => x.workId != work.workId);
    }
  }

  getLabourWorkList() {
    this.spinner.show();
    this.tecRMIService.getLabourWorkList(this.tecDocType).then(result => {
      if (result) {
        this.labourWorkList = result.responseObject;
      }
      this.spinner.hide();
    },
      _error => {
        this.spinner.hide();
      });
  }

  getWorkStepsByItemMpId() {
    let selectedLabourWorkFromStep3: LabourInfoViewModel[] = this.selectedLabourWorkFromStep2[0].childNodes.filter(x => x.isSelected )
    this.spinner.show();
    this.tecRMIService.getWorkStepsByItemMpId(this.tecDocType, selectedLabourWorkFromStep3[0].nodeKorId, selectedLabourWorkFromStep3[0].nodeId).then(result => {
      if (result) {
        this.workSteps = result.responseObject;
      }
      this.spinner.hide();
    },
      _error => {
        this.spinner.hide();
      });
  }

  addPartToCart(part: PartViewModel) {
    this.cartPartItems.push(part);
  }

  removePartFromCart(part: PartViewModel) {
    let index = this.cartPartItems.indexOf(part);
    if (index !== -1) {
      this.cartPartItems.splice(index, 1);
    }
    part.isChecked = false;
  }

  setPartListForWork(item: any) {
    let flag = false;
    if (item) {
      this.workSteps.forEach(s => {
        if (!flag) {
          s.exclusiveWorkPositions.forEach(element => {
            if (item.workId == element.workId) {
              element.parts = item.parts;
              flag = true;
            }
          });
        }
      });

      if (!flag) {
        this.workSteps.forEach(s => {
          if (!flag) {
            s.exclusiveWorkPositions.forEach(element => {
              if (item.workId == element.workId) {
                element.parts = item.parts;
                flag = true;
              }
            });
          }
        });
      }
    }
  }

  removeMainService(item) {
    let index1 = this.AddedServicesInCart.indexOf(item)
    if (index1 !== -1) {
      this.AddedServicesInCart.splice(index1, 1);
      this.selectedService = null;
      this.cartPartItems = this.cartPartItems.filter(x => x.workId != item.workId);

      this.workSteps.forEach(x => {
        x.exclusiveWorkPositions.forEach(ex => {
          if (ex.workId == item.workId) {
            ex.isSelected = false
            ex.parts.forEach(p => { p.isChecked = false })
          }
        })
      })
    }
  }


  getParts(element: WorkViewModel) {
    element.showParts = true;
  }

  showPreviousTab() {
    if (this.selectedtab == 2) {
      //step 1
      this.selectedtab = 1;
    }
    else if (this.selectedtab == 3) {
      //step 2
      this.selectedtab = 2;
    }
    else if (this.selectedtab == 4) {
      //step 3
      this.selectedtab = 3;
    }
    else if (this.selectedtab == 5) {
      // step 4
      this.cartPartItems = [];
      this.selectedtab = 4;
    }
    else if (this.selectedtab == 6) {
      // step 5
      this.selectedtab = 5;
    }
  }

  showNextTab() {
    if (this.selectedtab == 1) {
      //step 2
      this.selectedtab = 2;
    }
    else if (this.selectedtab == 2) {
      //step 3
      this.getSubChildLabourWorkListForStep3()
      this.selectedtab = 3;
    }
    else if (this.selectedtab == 3) {
      //step 4
      this.getWorkStepsByItemMpId()
      this.selectedtab = 4;
    }
    else if (this.selectedtab == 4) {
      //step 5
      this.selectedtab = 5;
    }
    else if (this.selectedtab == 5) {
      //step 6
      this.GetAvailableStock()
      this.selectedtab = 6;
    }
    else if (this.selectedtab == 6) {
      //check out
      this.SaveData()
      this.selectedtab = 6;
    }

  }

  GetAvailableStock() {
    this.spinner.show();
    let yFilter = this.cartPartItems.map(itemY => { return itemY.genArtNo; });

    let viewModel = {
      BranchId: this.appointmentDetails.dealerId,
      GenArtNumberList: yFilter
    }

    this.tecRMIService.getAvailableStock(viewModel).then(result => {
      if (result != null) {
        this.availableStockBalance = result.responseObject
      }
      this.spinner.hide();
    },
      _error => {
        this.spinner.hide();
      });
  }

  removeArticleFromCart(article: AvailableStockBalanceModel) {
    let index = this.articleStockData.indexOf(article);
    if (index !== -1) {
      this.articleStockData.splice(index, 1);
    }
    article.isChecked = false;
  }

  addRemoveArticleToCart(event: any, article: any) {
    if (event.target.checked) {
      article.IsChecked = true
      this.articleStockData.push(article);
    }
    else {
      article.IsChecked = false;
      let index = this.articleStockData.indexOf(article);
      if (index !== -1) {
        this.articleStockData.splice(index, 1);
      }
    }

  }
  SaveData() {
    let modelHeadermsg = this.translate.instant("lblAdd");
    let modelBodymsg = this.translate.instant("lblSureToAddLabor");
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {
      // This is intentional
    }, (reason) => {
      if (this.getDismissReason(reason)) {
        this.SaveServiceData()
      }

    });
  }
  private getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }

  SaveServiceData() {
    this.spinner.show();
    //create article purchase order in EM 
    let articleStockData = this.articleStockData;
    let LinesForPurchaseOrder = articleStockData.filter(x => x.localStock == 0)
    let articlePurchaseOrder = {
      BranchId: this.editAppointmentService.appointmentDetails.dealerId,
      AppointmentId: this.editAppointmentService.appointmentDetails.id,
      CustomerName: this.editAppointmentService.appointmentDetails.customerName,
      Lines: LinesForPurchaseOrder
        .map(article => ({
          ArticleName: article.name,
          SupplierArticleId: article.number,
          Price: article.listPrice,
          Discount: 0,
          Quantity: 1,
          Recyclefee: 0,
          Vat: article.vat
        }))
    }
    this.tecRMIService.createArticlePurchaseOrder(articlePurchaseOrder).then(result => {
      if (!isNullOrUndefined(result?.responseObject)) {
        this.mapAllArticleAndService();
        this.spinner.hide()
        this.OnClose();
      }
      else {
        this.spinner.hide()
        this.OnDismiss();
      }
      this.spinner.hide();
    },
      _error => {
        this.OnDismiss();
        this.spinner.hide();
      });
  }

  mapAllArticleAndService() {
    let operations = []

    let selectedPartList = this.articleStockData
      .map(article => ({
        description: article.name,
        number: article.number,
        price: article.listPrice,
        quantity: 1,
        pricing:
        {
          priceLevels:
            [{
              amount: article.listPrice
            }]
        }
      }));

      
    let labourDetails = []
    this.AddedServicesInCart.forEach(mainService => {
      let labour = {
        description: mainService.workText,
        times:
          [{
            quantity: mainService.workTime
          }]
      }
      labourDetails.push(labour)
    });


    let operation = {
      description: this.selectedServiceName,
      parts: selectedPartList,
      id: this.AddedServicesInCart[0].itemMpId,
      code: this.AddedServicesInCart[0].itemMpId,
      labourList: labourDetails
    }
    operations.push(operation)

    let ssmExportedResponseModel = {
      operations: operations
    }
    this.editAppointmentService.isExported = true;
    this.editAppointmentService.exportedJson = JSON.stringify(ssmExportedResponseModel);
  }

  OnDismiss() {
    this.activeModal.dismiss('Cross click')
  }

  OnClose() {
    this.activeModal.close("Save appointment data")
  }

}
